module.exports = __webpack_public_path__ + "02_short_brown.89226b63.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_short_brown.png
// module id = X8wR
// module chunks = 0